"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports.ProductDetail = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _inheritsLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/inheritsLoose"));

var _react = _interopRequireWildcard(require("react"));

var _mobxReact = require("mobx-react");

var _ProductGenericInfo = require("./ProductGenericInfo");

var _HtmlRender = require("../../react-static/components/HtmlRender");

var _Core = require("../../components/Core");

var _styled = require("../../styles/styled");

var _class;

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["flex-direction: column"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var ProductDetail = (0, _mobxReact.observer)(_class =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(ProductDetail, _Component);

  function ProductDetail(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = ProductDetail.prototype;

  _proto.render = function render() {
    var product = this.props.product; // const image = JSON.parse(product.image_large);
    // const imageStyle = {
    //   maxWidth: "433.721px",
    //   maxHeight: "452px",
    // };

    return _react.default.createElement(FlexWrapper, {
      p: 3
    }, _react.default.createElement(_Core.Box, {
      px: 3
    }, _react.default.createElement(_ProductGenericInfo.ProductGenericInfo, {
      productDetail: product
    }), _react.default.createElement("br", null), _react.default.createElement("h2", null, "Description"), _react.default.createElement("div", null, _react.default.createElement(_HtmlRender.HtmlRender, {
      html: product.descLong
    }))), _react.default.createElement(_Core.Flex, {
      flexDirection: "column",
      alignItems: "center",
      pb: 3,
      width: [1]
    }, _react.default.createElement(_Core.Image, {
      src: product.imageLarge
    })));
  };

  return ProductDetail;
}(_react.Component)) || _class;

exports.ProductDetail = ProductDetail;
var FlexWrapper = (0, _styled.styled)(_Core.Flex).withConfig({
  componentId: "sc-21xlaf-0"
})(["flex-direction:row;", ";"], _Core.media.screenLg(_templateObject()));